const PGAdapter = require('../../common/pg-adapter')

const LOCATION_SERVICE_TABLE_NAME = 'avocado.data_location_service'
const LOCATION_SERVICE_COLUMNS = [
  'id',
  'location_id',
  'service_id',
  'site_id',
  'start_date',
  'end_date',
  'funder_fsid',
  'implementing_partner_fsid',
  'created_at',
  'updated_at'
]

class LocationServicePgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_SERVICE_TABLE_NAME,
      username,
      LOCATION_SERVICE_COLUMNS,
      'id',
      {},
      logger
    )
  }

  async upsert (locationUuid, serviceUuid, locationServiceData) {
    const locationService = {
      location_id: locationUuid,
      service_id: serviceUuid,
      site_id: locationServiceData.site_id,
      start_date: locationServiceData.start_date,
      end_date: locationServiceData.end_date,
      funder_fsid: locationServiceData.funder_fsid,
      implementing_partner_fsid: locationServiceData.implementing_partner_fsid,
      created_at: locationServiceData.created_at,
      updated_at: new Date()
    }
    return super.upsert(locationService, { conflictIdColumns: ['location_id', 'service_id'] })
  }
}

module.exports = LocationServicePgAdapter
